import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";
import {icons} from "../../icons/Icons";
import * as array from "../../utils/array";

import {Dialog} from "../flipp-dialog/Dialog";
import {Link} from "../flipp-link/Link";

import {ClippingType, Clipping, LoyaltyCard} from "../../definitions/CommonDefinitions";
import {CouponRedemptionStatus, ClippedCoupon} from "../../definitions/CouponDefinitions";
import {inject} from "../../services/di";
import {ConfigService} from "../../services/ConfigService";
import {ShoppingListService, ShoppingList} from "../../services/ShoppingListService";
import {ClippingService} from "../../services/ClippingService";
import {CouponService} from "../../services/CouponService";
import {LoyaltyProgramService} from "../../services/LoyaltyProgramService";
import {AuthenticationService} from "../../services/AuthenticationService";
import {AuthStatus} from "../../services/definitions/IAuthenticationService";

@element("flipp-shopping-list-trigger-element")
export class ShoppingListTriggerElement extends Component<{selected: boolean}, {}> {

	@inject shoppingList: ShoppingListService;
	@inject config: ConfigService;
	@attr selected: boolean;

	refs: {
		shoppingListButton: HTMLButtonElement,
		slDialog: Dialog;
	};

	onAttach() {
		// window.addEventListener("flipp-auth", this._handleAuthChange);
		// window.addEventListener("flipp-shopping-list", this._handleSLChanged);
	}

	onDetach() {
		// window.removeEventListener("flipp-auth", this._handleAuthChange);
		// window.removeEventListener("flipp-shopping-list", this._handleSLChanged);
	}

	render() {

		const slPill = <div flex-horizontal class="pill-area">
			<span class="list-count">
				<ShoppingListPill />
			</span>
			<span class="label">{i18n("shopping_list")}</span>
		</div>;

		return <div class="sl-nav-area"
					classList={{selected: this.selected}}
					style={{backgroundColor: this.config.getThemeColor()}}>
			{!this.selected ?
				<Link class="sl-button"
								to="shopping_list"
								>
								{/*
								ref="shoppingListButton"
								anchor-point="right bottom"
								*/}
					{slPill}
				</Link>
			:
				<span>{slPill}</span>
			}

			{/*
			<Dialog class="embedded-shopping" ref="slDialog" transient popover anchor-point="right top">
				<section class="title-area" flex-horizontal>
					<div class="logo" flex-vertical>
						{icons.flippLogo}
					</div>
					<div class="value-area" flex-vertical>
						<h2>{i18n("embedded_shopping_list_title")}</h2>
						<h3>{i18n("embedded_shopping_list_desc")}</h3>
					</div>
					<button class="close" onClick={this._handleListClose}>
						<div flex-vertical>{icons.x}</div>
					</button>
				</section>

				<section class="shopping-list">
					<ShoppingListElement
						ref="list"
						onItemSelected={this._handleItemSelected}
						onItemAdded={this._handleItemAdded}
						context={ShoppingListContext.Embedded} />
				</section>
			</Dialog>
			*/}
		</div>;
	}

	// private _popoutShoppingList = () => {
	// 	this.refs.slDialog.showModal(this.refs.shoppingListButton);
	// }

	// private _handleListClose = () => {
	// 	this.refs.slDialog.close();
	// }

	// private _handleAuthChange = () => {
	// 	if (this.refs.slDialog.open) {
	// 		this.refs.list.invalidate();
	// 	}
	// }

	// private _handleSLChanged = () => {
	// 	if (this.refs.slDialog.open) {
	// 		this.refs.list.invalidate();
	// 	}
	// }

	// private _handleItemSelected = (item: SLSyncable) => {
	// 	return Promise.resolve<void>();
	// }

	// private _handleItemAdded = (item: string) => {
	// 	return Promise.resolve().then(() => {
	// 		this.shoppingList.localList.add([new SLListItem({
	// 			// Generate a fake UUID for now - it'll be clobbered by the server on save
	// 			id: `${item.toLowerCase().replace(/\s/g, "")}-${generateUUID()}`,
	// 			term: item,
	// 			checked: false
	// 		})]);
	// 	// TODO: track add
	// 	// this.analytics.trackShoppingListChanged(item, this.shoppingListService.localList.id,
	// 	//   ShoppingListAction.Add, context);
	// 	});
	// }
}

// flipp-shopping-list-pill ---------------------------------------------------->

@element("flipp-shopping-list-pill")
export class ShoppingListPill extends Component<{}, number> {

	@inject shoppingList: ShoppingListService;
	@inject clippingService: ClippingService;
	@inject config: ConfigService;
	@inject auth: AuthenticationService;
	@inject cardsService: LoyaltyProgramService;
	@inject couponsService: CouponService;

	prepare() {
		let getLoyaltyCardsFn = Promise.resolve<LoyaltyCard[]>([]);
		let getClippedCouponsFn = Promise.resolve<ClippedCoupon[]>([]);
		let slJoinFn = Promise.resolve<ShoppingList>({} as ShoppingList);
		if (this.auth.status === AuthStatus.LOGGED_IN) {
			getLoyaltyCardsFn = this.cardsService.getLoyaltyCards(this.auth.user);
			getClippedCouponsFn = this.couponsService.getClippedCoupons(this.auth.user);

			/* Call to join local list within the ShoppingListPill. Previously this call was
				* executed within the routes as a middleware, but that delayed the loading of the
				* entire UI until the join was complete. Instead we should return the Promise for
				* the join operation from prepare() so we can take advatange of the renderLoading()
				* API and show the UI before content is ready */
			if (!this.shoppingList.localList.isDelegate) {
				slJoinFn = this.shoppingList.joinLocalList(this.auth.user.token);
			}
		}

		return Promise.all([
			this.clippingService.getClippings(),
			this.couponsService.getCoupons(),
			this.cardsService.getLoyaltyPrograms(),
			getLoyaltyCardsFn,
			getClippedCouponsFn,
			slJoinFn
		]).then(([clippings, coupons, programs, loyaltyCards, clippedCoupons]) => {
			const validCoupons = clippedCoupons.filter((clippedCoupon) =>
					clippedCoupon.status === CouponRedemptionStatus.CLIPPED)
					.filter((clippedCoupon) => {
						const card = array.find(loyaltyCards,
							(card) => clippedCoupon.program.loyaltyProgramId === card.loyaltyProgramId);
						const program = array.find(programs,
							(program) => program.id === clippedCoupon.program.loyaltyProgramId);
						const coupon = array.find(coupons,
							(coupon) => coupon.id === clippedCoupon.program.couponId);
						return card && program && coupon;
					});

			/* Create a map of coupon ids for easy lookup */
			const couponIds: {[key: number]: boolean} = {};
			coupons.forEach((coupon) => couponIds[coupon.id] = true);

			const prunedClippings: Clipping[] = [];
			clippings.forEach((clipping) => {
				/* Don't show print coupons that are not available in the current locale */
				if (clipping.type === ClippingType.PRINT_COUPON && couponIds[Number(clipping.item.id)]) {
					prunedClippings.push(clipping);
				} else if (clipping.type !== ClippingType.PRINT_COUPON) {
					prunedClippings.push(clipping);
				}
			});

			this.shoppingList.startSync();

			return validCoupons.length + this.shoppingList.localList.size + prunedClippings.length;
		});
	}

	onAttach() {
		window.addEventListener("flipp-auth", this._handleSLChanged);
		window.addEventListener("flipp-shopping-list", this._handleSLChanged);
		window.addEventListener("flipp-clippingschanged", this._handleSLChanged);
	}

	onDetach() {
		window.removeEventListener("flipp-auth", this._handleSLChanged);
		window.removeEventListener("flipp-shopping-list", this._handleSLChanged);
		window.removeEventListener("flipp-clippingschanged", this._handleSLChanged);
	}

	renderLoading() {
		return this._doRender(true, 0);
	}

	render(size: number) {
		return this._doRender(false, size);
	}

	private _doRender(loading: boolean, size: number) {
		return <div>
			<div class="sl-icon"><img class="icon" src="https://f.wishabi.net/creative/Distribution/images/icons/myListIcon.svg" alt=""/></div>
			{loading ?
				<div class="sl-count-loading">
					<div class="spinner"></div>
				</div>
			: size > 0 ? <span class="count" flex-vertical>{size}</span> : null
			}
		</div>;
	}

	private _handleSLChanged = () => {
		this.invalidate();
	}
}
